import { TrackableAction } from '@apps/clos-sessions/state/processing';

export class FetchCloudSpace implements TrackableAction {
  static readonly type = '[Cloud] Fetch Cloud Space';

  readonly track = true;
}
